import "./Pricing.scss";
import { Component } from "react";

export default class Pricing extends Component {
  pricingTiers = [
    {
      name: "Starter",
      price: "$49",
      period: "/mo",
      recommended: false,
      features: [
        "5 posts per month",
        "1 social channel",
        "$10/mo per extra channel",
        "Dedicated marketing specialist",
        "Monthly strategy call"
      ]
    },
    {
      name: "Growth",
      price: "$99",
      period: "/mo",
      recommended: true,
      features: [
        "10 posts per month",
        "2 videos",
        "2 social channels",
        "$10/mo per extra channel",
        "Dedicated marketing specialist",
        "Bi-weekly strategy calls",
        "Priority support"
      ]
    },
    {
      name: "Professional",
      price: "$199",
      period: "/mo",
      recommended: false,
      features: [
        "20 posts per month",
        "5 videos",
        "5 Stories",
        "3 Carousels",
        "3 social channels",
        "Dedicated marketing specialist",
        "Weekly strategy calls",
        "Priority support",
        "Basic analytics reports"
      ]
    },
    {
      name: "Enterprise",
      price: "$399",
      period: "/mo",
      recommended: false,
      features: [
        "40 posts per month",
        "10 videos",
        "15 Stories",
        "8 Carousels",
        "1 Email campaign",
        "1 Blog post",
        "Unlimited social channels",
        "Dedicated marketing team",
        "Weekly strategy calls",
        "Priority support",
        "Advanced analytics & reports"
      ]
    }
  ];

  render() {
    return (
      <div className="pricing-container">
        <div className="pricing-header">
          <h1>Simple, Transparent Pricing</h1>
          <p>Choose the perfect plan for your business. Cancel anytime.</p>
        </div>

        <div className="pricing-cards">
          {this.pricingTiers.map((tier, index) => (
            <div
              key={index}
              className={`pricing-card ${tier.recommended ? 'recommended' : ''}`}
            >
              {tier.recommended && (
                <div className="recommended-badge">Recommended</div>
              )}
              <h2 className="plan-name">{tier.name}</h2>
              <div className="price-section">
                <span className="price">{tier.price}</span>
                <span className="period">{tier.period}</span>
              </div>
              <ul className="features-list">
                {tier.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>
                    <span className="checkmark">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <a href="https://calendly.com/dealigense/demo" target="_blank" rel="noreferrer">
                <button className={`pricing-btn ${tier.recommended ? 'btn-primary' : 'btn-secondary'}`}>
                  Get Started
                </button>
              </a>
            </div>
          ))}
        </div>

        <div className="pricing-footer">
          <p>All plans include onboarding & dedicated support</p>
          <p>First month includes up to 3 rounds of revisions</p>
          <p>Cancel anytime - no long-term contracts required</p>
        </div>
      </div>
    );
  }
}
